import { formatSignupInput } from '@jetshop/core/components/Auth/formatSignupInput';
import useAuth from '@jetshop/core/components/AuthContext/useAuth';
import SignupMutation from '@jetshop/core/data/mutations/signup.gql';
import getErrorDetail from '@jetshop/core/helpers/getErrorDetail';
import t from '@jetshop/intl';
import { useApolloClient, useMutation } from '@apollo/react-hooks';
import { useContext } from 'react';
import { SignupContext } from './signup-context';
import { trackRegisterEvent } from '../../analytics/tracking';
import { useTracker } from '../../analytics/Analytics';
export function useSignupSubmit() {
    const [mutate] = useMutation(SignupMutation);
    const client = useApolloClient();
    const { logIn } = useAuth();
    const { isUserTypeBusiness } = useContext(SignupContext);
    const track = useTracker();
    return function signup({ values, actions }) {
        // Set the Formik state to submitting…
        actions.setSubmitting(true);
        mutate({
            variables: {
                input: formatSignupInput(values, {
                    userType: isUserTypeBusiness ? 'COMPANY' : 'PRIVATE'
                })
            }
        })
            .then(resp => {
            // Submitting is done
            actions.setSubmitting(false);
            // Track user register in GTAG
            track(trackRegisterEvent());
            // Reset the Apollo store
            client.resetStore().then(() => {
                // Log the user in with the token from signup
                logIn(resp.data.signUp.token.value);
            });
        }, error => {
            const errorDetail = getErrorDetail(error);
            // Submitting is done
            actions.setSubmitting(false);
            // Todo: improve error handling
            if (errorDetail.codes.includes('InvalidCreateCustomerInput')) {
                // Here we are checking if the error is related to the email address
                setAlreadySignedUpError(errorDetail, actions);
            }
            else {
                // Generic error
                actions.setStatus({
                    globalError: t('Something went wrong. Please try again.')
                });
            }
        })
            .catch(err => {
            console.log(err);
            actions.setSubmitting(false);
        });
    };
}
function setAlreadySignedUpError(errorDetail, actions) {
    const emailError = errorDetail.data.find((c) => Object.keys(c)[0] === 'EmailAddress');
    // If the code is UniqueValueAlreadyExists, the user has already signed up
    const hasAlreadySignedUp = emailError &&
        Object.values(emailError)[0][0] === 'UniqueValueAlreadyExists';
    // So set the error to something relevant
    actions.setStatus({
        globalError: hasAlreadySignedUp
            ? t('You have already signed up with this email address')
            : t('Something went wrong. Please try again.')
    });
}
//# sourceMappingURL=signupSubmit.js.map